// extracted by mini-css-extract-plugin
export var backButton = "_y-1";
export var content = "_y-d";
export var continueButton = "_y-7";
export var continueHint = "_y-8";
export var continueRow = "_y-6";
export var leftInner = "_y-0";
export var sidebarContent = "_y-5";
export var skipButton = "_y-c";
export var spacer = "_y-2";
export var spin = "_y-a";
export var spinner = "_y-9";
export var spinnerOverlay = "_y-b";
export var subtitle = "_y-4";
export var title = "_y-3";